/* eslint-disable react/prop-types */
import { Box, Card, Container, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { m } from 'framer-motion';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import Image from '../../components/Image';
import { MotionViewport, varFade } from '../../components/animate';

const Item = styled(Card)(({ theme }) => ({
  ...theme.typography.body2,
  backgroundColor: theme.palette.background.neutral,
  padding: theme.spacing(0),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  paddingBottom: 20,
  '&:hover': {
    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
  },
  cursor: 'pointer'
}));

const Header = styled(Box)(({ theme }) => ({
  width: 70,
  borderRadius: 25,
  padding: 5,
  ...theme.typography.body1,
  color: "#fff"
}));

export function SituationHeader() {
  return (
    <Container component={MotionViewport} sx={{ my: 5 }} disableGutters maxWidth="xl">
      <m.div variants={varFade().inDown}>
        {/* <Typography variant={'h2'} textAlign={"center"} textTransform={"capitalize"}>
          {translate('situation.title')} {new Date().getFullYear()}
        </Typography> */}
        <MenuDashboard />
      </m.div>
    </Container>
  );
}

export const MenuDashboard = () => {
  const { answers } = useSelector((state) => state.situation);
  const { exams } = useSelector((state) => state.examS);
  const { failedSituations } = useSelector((state) => state.failSituation);

  return (
    <Grid container spacing={3}>
      <Grid item xs={6} sm={3}>
        <Link href="/thi-tinh-huong/" style={{ textDecoration: 'none' }} passHref>
          <Item >
            <Header sx={{ backgroundColor: '#12779b' }}>{answers?.length}_120</Header>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Image alt={"Ôn tập"} src={"/icons/augmented-reality.png"} sx={{ height: 50, width: 50, mb: 1 }} />
            </Box>
            <Typography variant="subtitle1">Ôn tập câu hỏi</Typography>
          </Item>
        </Link>
      </Grid>
      <Grid item xs={6} sm={3}>
        <Link href="/thi-gplx/thi-that/" style={{ textDecoration: 'none' }} passHref>
          <Item>
            <Header sx={{ backgroundColor: '#0a255e' }}>*</Header>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Image alt={"Câu làm sai"} src={"/icons/quiz.png"} sx={{ height: 50, width: 50, mb: 1 }} />
            </Box>
            <Typography variant="subtitle1">Thi mô phỏng</Typography>
          </Item>
        </Link>
      </Grid>
      <Grid item xs={6} sm={3}>
        <Link href="/thi-tinh-huong/thi-thu/" style={{ textDecoration: 'none' }} passHref>
          <Item>
            <Header sx={{ backgroundColor: '#ed7a57' }}>{exams?.length}_12</Header>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Image alt={"Thi thử mô phỏng"} src={"/icons/simulator.png"} sx={{ height: 50, width: 50, mb: 1 }} />
            </Box>
            <Typography variant="subtitle1">Thi MP kèm gợi ý</Typography>
          </Item>
        </Link>
      </Grid>
      <Grid item xs={6} sm={3}>
        <Link href="/thi-tinh-huong/cau-sai/" style={{ textDecoration: 'none' }} passHref>
          <Item>
            <Header sx={{ backgroundColor: '#d73d62' }}>{failedSituations.length}_50</Header>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Image alt={"Câu làm sai"} src={"/icons/warning.png"} sx={{ height: 50, width: 50, mb: 1 }} />
            </Box>
            <Typography variant="subtitle1">Câu làm sai</Typography>
          </Item>
        </Link>
      </Grid>
    </Grid>
  );
};